import { put, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  LOAD_COMMUNITY_CONFIGS,
  LOAD_COMMUNITY_MEMBERSHIPS,
  LOAD_COMMUNITY_OWNERSHIPS, LOAD_COMMUNITY_STATISTICS,
  LOAD_MORE_COMMUNITY_MEMBERSHIPS
} from "../actions/actionTypes";
import {
  communityConfigsLoading,
  communityManagementMembershipsLoading,
  communityOwnershipsLoading, communityStatisticsLoading,
  loadCommunityConfigsSuccess,
  loadCommunityMembershipsError,
  loadCommunityMembershipsSuccess,
  loadCommunityOwnershipsError,
  loadCommunityOwnershipsSuccess,
  loadCommunityStatisticsSuccess,
  loadMoreCommunityManagementMembershipsLoading,
  loadMoreCommunityMembershipsSuccess
} from "../actions/communitiesActions";
import ICommunityOwnership from "../../communities/types/ICommunityOwnership";
import {
  getCommunityConfig,
  getCommunityManagementMemberships,
  getCommunityOwnerships, getCommunityStatistics
} from "../../communities/api/communitiesApi";
import { ILoadCommunityMgmtMembershipsFilter } from "../../communities/types/ILoadCommunityMgmtMembershipsFilter";
import { IPagedCommunityMgmtMemberships } from "../../communities/types/IPagedCommunityMgmtMemberships";
import { ICommunityStatistic } from "../../communities/types/ICommunityStatistic";

function* loadCommunityOwnerships() {
  try {
    yield put(communityOwnershipsLoading(true));
    const communityOwnerships: ICommunityOwnership[] = yield getCommunityOwnerships();
    yield put(loadCommunityOwnershipsSuccess(communityOwnerships));
  } catch (err) {
    yield put(loadCommunityOwnershipsError(err.message));
  } finally {
    yield put(communityOwnershipsLoading(false));
  }
}

function* loadCommunityManagementMemberships(action: { type: string, filter: ILoadCommunityMgmtMembershipsFilter }
) {
  try {
    yield put(communityManagementMembershipsLoading(true));
    const communityMemberships: IPagedCommunityMgmtMemberships = yield getCommunityManagementMemberships(action.filter);
    yield put(loadCommunityMembershipsSuccess(communityMemberships));
  } catch (err) {
    yield put(loadCommunityMembershipsError(err.message));
  } finally {
    yield put(communityManagementMembershipsLoading(false));
  }
}

function* loadMoreCommunityManagementMemberships(action: { type: string, filter: ILoadCommunityMgmtMembershipsFilter }) {
  try {
    yield put(loadMoreCommunityManagementMembershipsLoading(true));
    const communityMemberships: IPagedCommunityMgmtMemberships = yield getCommunityManagementMemberships(action.filter);
    yield put(loadMoreCommunityMembershipsSuccess(communityMemberships));
  } catch (err) {
    yield put(loadCommunityMembershipsError(err.message));
  } finally {
    yield put(loadMoreCommunityManagementMembershipsLoading(false));
  }
}

function* loadCommunityConfigs(action: { type: string, communityCodes: string[] }) {
  if (!action.communityCodes.length) {
    return yield put(loadCommunityConfigsSuccess([]));
  }
  try {
    yield put(communityConfigsLoading(true));
    const configs = yield Promise.all(
      action.communityCodes.map(communityCode => getCommunityConfig(communityCode))
    );
    yield put(loadCommunityConfigsSuccess(configs));
  } catch (err) {
    yield put(loadCommunityOwnershipsError(err.message));
  } finally {
    yield put(communityConfigsLoading(false));
  }
}

function* loadCommunityStatistics() {
  try {
    yield put(communityStatisticsLoading(true));
    const statistics: ICommunityStatistic[] = yield getCommunityStatistics();
    yield put(loadCommunityStatisticsSuccess(statistics));
  } catch (err) {
    yield put(loadCommunityOwnershipsError(err.message));
  } finally {
    yield put(communityStatisticsLoading(false));
  }
}

function* communitiesSaga() {
  yield takeEvery(LOAD_COMMUNITY_OWNERSHIPS, loadCommunityOwnerships);
  yield takeLatest(LOAD_COMMUNITY_MEMBERSHIPS, loadCommunityManagementMemberships);
  yield takeEvery(LOAD_MORE_COMMUNITY_MEMBERSHIPS, loadMoreCommunityManagementMemberships);
  yield takeEvery(LOAD_COMMUNITY_CONFIGS, loadCommunityConfigs);
  yield takeEvery(LOAD_COMMUNITY_STATISTICS, loadCommunityStatistics);
}


export default communitiesSaga;


// WEBPACK FOOTER //
// ./src/modules/core/sagas/communitiesSaga.tsx